import type { Moment } from 'moment';
import type { Bays, IClientSupervision } from '../../../../../utils/types';

type ClientIdInput = number | '' | null | undefined;

interface StartClientSupervisionButtonDisabledParams {
  isFormValid: boolean;
  isFormDirty: boolean;
  isSubmitting: boolean;
  timeStartValue: Moment | null;
  clientSupervision: IClientSupervision | null;
  durationToolTipOpen: boolean;
  timeToolTipOpen: boolean;
}

export function isStartClientSupervisionButtonDisabled(
  params: StartClientSupervisionButtonDisabledParams,
): boolean {
  const {
    isFormValid,
    isFormDirty,
    isSubmitting,
    timeStartValue,
    clientSupervision,
    durationToolTipOpen,
    timeToolTipOpen,
  } = params;

  const isDisabled =
    !(isFormValid && isFormDirty) ||
    isSubmitting ||
    !timeStartValue ||
    Boolean(
      clientSupervision != null && Object.prototype.hasOwnProperty.call(clientSupervision, 'id'),
    ) ||
    durationToolTipOpen ||
    timeToolTipOpen;

  return isDisabled;
}

export function resolveClientIdFromFormOrSupervision(
  clientIdFromForm: ClientIdInput,
  clientIdFromSupervision: ClientIdInput,
): number | null {
  if (clientIdFromForm !== '' && clientIdFromForm != null) {
    return clientIdFromForm;
  }
  if (clientIdFromSupervision !== '' && clientIdFromSupervision != null) {
    return clientIdFromSupervision;
  }
  return null;
}

interface ShouldShowNoActiveBtsMessageParams {
  clientSupervision: IClientSupervision | null;
  btParticipantsQueried: boolean;
  providerAssignmentLoading: boolean;
  coAssignedProvidersLoading: boolean;
  timeStartValue: Moment | null;
  bayActiveAtDateTime: Bays | undefined;
  isBay6: boolean;
}

export function shouldShowNoActiveBtsMessage(params: ShouldShowNoActiveBtsMessageParams): boolean {
  const {
    clientSupervision,
    btParticipantsQueried,
    providerAssignmentLoading,
    coAssignedProvidersLoading,
    timeStartValue,
    bayActiveAtDateTime,
    isBay6,
  } = params;

  const hasSupervisionContext = clientSupervision != null;
  const btAndAssignmentListsReady =
    btParticipantsQueried && !providerAssignmentLoading && !coAssignedProvidersLoading;
  const sessionStartTimeIsSet = Boolean(timeStartValue);
  const doesNotHaveBay6 = Boolean(bayActiveAtDateTime) && !isBay6;

  return (
    hasSupervisionContext && btAndAssignmentListsReady && sessionStartTimeIsSet && doesNotHaveBay6
  );
}
